module.exports = __webpack_public_path__ + "img/qilin-f-stage6-sulking.039e82bf.png";